import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { printWelcome } from '@/lib/console'
import store from '@/lib/store'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import { StoreSessionActions } from '@/lib/store/modules/session/actions'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

/**
 * 初始化
 */
printWelcome()

document.documentElement.style.overflowX = 'hidden'

setInterval(() => {
  store.dispatch(StoreSessionActions.doTokenRefresh).finally(null)
}, 60 * 1000)

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, { locale: _unref(zhCN) }, {
    default: _withCtx(() => [
      _createVNode(_component_router_view)
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})